
export default{
    setRoles(state, msg) {
        state.roles = msg;
    } ,
    setUserName(state, msg) {
        state.userName = msg;
    },
    setLeaderFirst(state, msg) {
        state.leaderFirst = msg;
    },
    setStaffCode(state, msg){
        state.staffCode = msg;
    },
    setStaffStatus(state, msg){
        state.staffStatus = msg;
    },
    setTokens(state, msg) {
        state.tokens = msg;
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js